import React, { FC, useCallback, useState } from 'react';
import { getEntityById } from '../../utils/DataAccessUtils';
import { updateChangeApplyStatus } from '../../thunks/acc_audits_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { message } from 'antd';
import { withUserType } from '../withUserType';
import ACCAuditStatusSelect from './ACCAuditStatusSelect';

const ACCAuditChangeActions: FC<any> = ({
	accAudit,
	updateChangeApplyStatus,
}): React.ReactElement => {
	const [updating, setUpdating] = useState(false);

	const onStatusChange = useCallback(
		(status) => {
			setUpdating(true);
			updateChangeApplyStatus(accAudit, status)
				.catch(message.error)
				.finally(() => setUpdating(false));
		},
		[accAudit, updateChangeApplyStatus]
	);

	return (
		<ACCAuditStatusSelect
			value={accAudit.changeApplyStatus}
			onChange={onStatusChange}
			size="middle"
			loading={updating}
		/>
	);
};

const mapStateToProps = (state, ownProps) => ({
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_runs),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateChangeApplyStatus: (entity, status) =>
		dispatch(updateChangeApplyStatus(ownProps.userType)(entity, status)),
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(ACCAuditChangeActions as any))
);
